export default class FechamentoMes {
    
    constructor(model = null){
        this.id = 0;
        this.empresaId = 0;
        this.mes = new Date().getMonth() == 0 ? 12 : new Date().getMonth();
        this.ano = new Date().getFullYear();

        if (!model)
            return;
        
        this.id = model.id ? model.id : 0;
        this.empresaId = model.empresaId;
        this.mes = model.mes; 
        this.ano = model.ano;
    }
}